import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
import { scrollTop } from '@/libs/util';
import { on, off } from '@/libs/tools';
var prefixCls = 'ivu-back-top';
export default {
  name: 'ABackTop',
  props: {
    height: {
      type: Number,
      default: 400
    },
    bottom: {
      type: Number,
      default: 30
    },
    right: {
      type: Number,
      default: 30
    },
    duration: {
      type: Number,
      default: 1000
    },
    container: {
      type: null,
      default: window
    }
  },
  data: function data() {
    return {
      backTop: false
    };
  },
  mounted: function mounted() {
    // window.addEventListener('scroll', this.handleScroll, false)
    // window.addEventListener('resize', this.handleScroll, false)
    on(this.containerEle, 'scroll', this.handleScroll);
    on(this.containerEle, 'resize', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll, false)
    // window.removeEventListener('resize', this.handleScroll, false)
    off(this.containerEle, 'scroll', this.handleScroll);
    off(this.containerEle, 'resize', this.handleScroll);
  },
  computed: {
    classes: function classes() {
      return ["".concat(prefixCls), _defineProperty({}, "".concat(prefixCls, "-show"), this.backTop)];
    },
    styles: function styles() {
      return {
        bottom: "".concat(this.bottom, "px"),
        right: "".concat(this.right, "px")
      };
    },
    innerClasses: function innerClasses() {
      return "".concat(prefixCls, "-inner");
    },
    containerEle: function containerEle() {
      return this.container === window ? window : document.querySelector(this.container);
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      this.backTop = this.containerEle.scrollTop >= this.height;
    },
    back: function back() {
      var target = typeof this.container === 'string' ? this.containerEle : document.documentElement || document.body;
      var sTop = target.scrollTop;
      scrollTop(this.containerEle, sTop, 0, this.duration);
      this.$emit('on-click');
    }
  }
};